export default (params) => ({
  trigger: {
    name: 'cross_sell_recommendations.shown_recommendations',
    params: params,
  },
  config: {
    schema: {
      primary_item_id: {
        type: 'integer',
      },
      attached_item_ids: {
        pattern: '^[1-9][0-9]*(?:,[1-9][0-9]+)*$',
      },
      sub_feature: {
        enum: [
          'configurator_overlay',
          'accessory_checkbox_overlay',
          'add_to_cart_page_overlay',
          'options_row_overlay',
          'add_to_cart_overlay_overlay',
          'product_type_section_alternative_overlay',
          'recommended_accessories_alternative_overlay',
        ],
      },
    },
    event: {
      name: 'show_accessory_items',
    },
    nonInt: true,
  },
});
